import React from "react";
import { useNavigate } from "react-router-dom";
import start from "../../../assets/img/icons/star.svg";
const SpecialTipCard = ({ info }) => {
  function round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}
const navigate = useNavigate()
  return (
<div className="SpecialTipCard w-[309px] rounded-[30px]"  onClick={() => {
        navigate(`/place/${info.code}/${info.slug}`);
      }}>
  <div
    className="SpecialTipCard__img  w-[309px] h-[386px] "
    style={{ backgroundImage: `url(${info.thumbnail?.thumbnail_path})` }}
  />
  <div className="white-bg SpecialTipCard__sub">
    <div className="flex items-start">
      {" "}<img src={start} className='mr-[5px]'/>
      <p className="text-[#12171C] font-bold">   {round(info.rating_value,1)}</p>
    </div>
    <h4 className="text-[24px] text-[#292D32] my-[5px]">
     {info.title}
    </h4>
    <div className="text-[17px] text-[#797D82] SpecialTipCard--info">
      {info.rooms_count} اتاق خواب ، {info.area_size} متر ، تا {info.max_capacity} مهمان
    </div>
    <div className="flex price-box justify-end mt-[10px]">
         
    <div className="pre-cost">از</div>
      <div className="cost mx-2">
      {info.price}
      </div>
      <div className="pre-cost">تومان</div>
    </div>
  </div>
     
</div>

  );
};

export default SpecialTipCard;
